import React from 'react'

import { useSelector } from 'react-redux'
import { Row, Col, CustomInput } from 'reactstrap'
import { I18n } from 'react-redux-i18n'

import DKV_CONSTANTS from 'constants/dkv.constants'
import flagEnvDisplay from 'constants/flagEnvDisplay'
import { hasModuleNotFree } from 'services/PlanRestrictions'

/**
 * @param {object} props
 * @param {object} props.modules
 * @param {function} props.toggleModule
 */
const PlanModules = (props) => {
  const { toggleModule, modules } = props

  const { _id: companyId } = useSelector(store => store.companies)
  const currentPlan = useSelector(store => store.currentPlan)

  if (!hasModuleNotFree(currentPlan)) return null

  return (
    <>
      <Row className='mt-5'>
        <Col>
          <h1>{I18n.t('dashboard_service-configuration')}</h1>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className='my-3'>{I18n.t('plan_service_config_subtitle')}</div>
          <div className='plan-switch-container'>
            {
              DKV_CONSTANTS.isDKV
                ? null
                : (
                  <CustomInput
                    type='switch'
                    className='switch'
                    id='consoleSwitch'
                    label={I18n.t('dashboard_virtual-assistant')}
                    checked={modules.faqConsole.isActive}
                    onChange={(c) => toggleModule('faqConsole', c.target.checked)}
                  />
                )
            }
            {modules.smartChat.isActive && (
              <CustomInput
                type='switch'
                className='switch'
                id='smartChat'
                label={I18n.t('dashboard_smartchat')}
                checked={modules.smartChat.isActive}
                onChange={(c) => toggleModule('smartChat', c.target.checked)}
              />
            )}
            {
              DKV_CONSTANTS.isDKV
                ? null
                : (
                  <CustomInput
                    type='switch'
                    className='switch'
                    id='GMPSwitch'
                    label={I18n.t('dashboard_chat-marketing')}
                    checked={modules.crmMarketing.isActive}
                    onChange={(c) => toggleModule('crmMarketing', c.target.checked)}
                  />
                )
            }
            <CustomInput
              type='switch'
              className='switch'
              id='metricsBasic'
              label={I18n.t('dashboard_metrics-kpis')}
              checked={modules.metricsBasic.isActive}
              onChange={(c) => toggleModule('metricsBasic', c.target.checked)}
            />
            {
              flagEnvDisplay.displayEcommercePlugin(companyId) && (
                <CustomInput
                  type='switch'
                  className='switch'
                  id='pluginEcommerce'
                  label={I18n.t('dashboard_ecommerce-plugin')}
                  checked={modules.pluginEcommerce.isActive}
                  onChange={(c) => toggleModule('pluginEcommerce', c.target.checked)}
                />
              )
            }
            {
              flagEnvDisplay.displayEcommerceAV(companyId) && (
                <CustomInput
                  type='switch'
                  className='switch'
                  id='smartChatEcommerce'
                  label={I18n.t('dashboard_smartchat-ecommerce')}
                  checked={modules.smartChatEcommerce.isActive}
                  onChange={(c) => toggleModule('smartChatEcommerce', c.target.checked)}
                />
              )
            }
          </div>
        </Col>
      </Row>
    </>
  )
}

export default PlanModules